// extracted by mini-css-extract-plugin
export default {"fileEditContainer":"styles_fileEditContainer__iRMBH","fileName":"styles_fileName__+T1F7","deleteButton":"styles_deleteButton__20RGK"};